const C = {
  name: "Scale",
  dimensions: { width: 40, height: 40 },
  content: `
<svg fill="none">
<g clip-path="url(#clip0_3699_59)">
<path d="M20 0C31.0423 0 40 8.95772 40 20C40 31.0423 31.0423 40 20 40C17.0415 40 14.2244 39.3493 11.6953 38.1904C10.4534 39.3145 8.80702 40 7 40C3.13401 40 0 36.866 0 33C0 31.193 0.684452 29.5456 1.80859 28.3037C0.650023 25.7749 0 22.9581 0 20C0 8.95772 8.95772 0 20 0ZM7 28C4.23858 28 2 30.2386 2 33C2 35.7614 4.23858 38 7 38C9.76142 38 12 35.7614 12 33C12 30.2386 9.76142 28 7 28ZM20 2C10.0623 2 2 10.0623 2 20C2 22.4762 2.50611 24.84 3.41406 26.9873C4.46288 26.3604 5.68931 26 7 26C10.866 26 14 29.134 14 33C14 34.3106 13.6385 35.5362 13.0117 36.585C15.1594 37.4932 17.5234 38 20 38C29.9377 38 38 29.9377 38 20C38 10.0623 29.9377 2 20 2Z" fill="currentColor"/>
</g>
<defs>
<clipPath id="clip0_3699_59">
<rect width="40" height="40" fill="white"/>
</clipPath>
</defs>
</svg>

    `
};
export {
  C as Scale
};
